export function useDelay() {
  async function delay(milliseconds: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  function timeout(milliseconds: number): Promise<never> {
    return new Promise((_, reject) =>
      setTimeout(() => reject(new Error("timeout")), milliseconds),
    );
  }

  return { delay, timeout };
}
